{
  "learner": {
    "brand": {
      "routerLink": "/<user>/home/overview",
      "mark": {
        "url": "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='%230062E3' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath class='logo' fill-rule='evenodd' clip-rule='evenodd' d='M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z' /%3E%3C/svg%3E",
        "altText": "Degreed logo"
      },
      "logo": {
        "url": "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='268' height='54' viewBox='0 0 134 27' fill='none'%3E%3Cpath d='M27.344 18.1522C26.3963 18.9499 25.2299 19.4576 23.9176 19.4576C22.0222 19.5301 20.7099 19.3125 19.9809 17.717C18.8874 15.4688 19.4706 14.0909 19.5435 13.8733C20.4183 12.1327 27.1253 11.6976 27.7814 13.0756C28.2188 13.8008 28.3647 17.1369 27.344 18.1522ZM11.6701 17.717C10.9411 19.3125 9.62883 19.5301 7.73337 19.4576C6.49404 19.4576 5.2547 19.0225 4.30698 18.1522C3.35925 17.0643 3.43215 13.8008 3.79666 13.0756C4.52568 11.6976 11.1598 12.1327 12.0346 13.8733C12.1804 14.0909 12.7636 15.4688 11.6701 17.717ZM30.9162 10.6098L21.2932 5.38809L21.0015 5.17052C20.4183 4.95295 19.8351 4.95295 19.3248 5.17052L18.9603 5.38809L17.4293 6.25837V6.33089L18.0126 6.62099L21.6577 8.57911L23.7718 9.73949C21.6577 9.88453 19.5435 10.5372 17.721 11.5526C17.2106 11.8427 16.5545 12.0602 15.9713 12.0602H15.8255C15.1694 12.0602 14.5862 11.9152 14.0759 11.5526C12.1804 10.5372 10.1391 9.88453 8.02498 9.73949L15.8984 5.38809L18.7416 3.79258C19.4706 3.28492 20.3454 3.13987 21.2203 3.35744C21.9493 3.64754 22.6054 3.93763 23.2615 4.37277C23.5531 4.51782 23.8447 4.59034 24.1363 4.51781C24.4279 4.44529 24.6466 4.30025 24.8654 4.08268C25.0841 3.86511 25.157 3.50249 25.157 3.2124C25.157 2.77726 24.9383 2.34212 24.5008 2.05203C23.5531 1.39932 22.4596 0.964178 21.2932 0.674086C18.6687 0.238946 16.9919 1.47184 15.7526 2.19707C14.2217 0.96418 12.1804 0.383993 10.212 0.674086C9.04561 0.964178 8.02498 1.39932 7.00435 2.05203C6.42114 2.48717 6.20243 3.28492 6.63984 3.86511C6.63984 3.93763 6.71274 3.93763 6.71274 4.01015C7.00435 4.30025 7.36886 4.44529 7.73337 4.44529C7.95208 4.44529 8.17079 4.37277 8.38949 4.22772C9.04561 3.86511 9.70173 3.50249 10.4307 3.2124C11.3056 2.99483 12.2533 3.2124 12.9823 3.72006L0.807678 10.6098C0.51607 10.7548 0.297363 11.1174 0.297363 11.48V13.1481C0.297363 13.5107 0.51607 13.8733 0.807678 14.0183C1.09929 14.1634 1.17219 14.3084 1.17219 14.8886C1.17219 15.9765 0.443168 21.7783 8.09788 21.7783C14.9507 21.7783 14.1488 15.1062 15.8255 15.1062C17.5022 15.1062 16.7003 21.7783 23.5531 21.7783C31.2078 21.7783 30.4788 15.9765 30.4788 14.8886C30.4788 14.3084 30.5517 14.1634 30.8433 14.0183C31.2078 13.8733 31.4265 13.5107 31.4265 13.1481V11.48C31.4994 11.1174 31.2807 10.7548 30.9162 10.6098Z' fill='%230062E3'/%3E%3Cpath d='M70.1374 14.8887C70.2103 14.236 70.5019 13.6558 71.0122 13.2206C71.7413 12.6405 72.6161 12.3504 73.5638 12.4229C74.4386 12.3504 75.3135 12.6405 75.9696 13.2206C76.4799 13.6558 76.7715 14.3085 76.8444 14.9612V15.759C76.8444 16.4117 76.6257 17.0644 76.1883 17.572C76.1154 17.6446 76.0425 17.7896 75.8967 17.8621C75.6051 18.1522 75.1677 18.3698 74.8031 18.5148C74.3657 18.6599 73.8554 18.7324 73.3451 18.7324C72.4703 18.8049 71.5954 18.5148 70.9393 17.8621C70.8664 17.7896 70.7206 17.7171 70.6477 17.572C70.2103 16.9919 69.9916 16.2666 70.0645 15.5414C70.0645 15.3238 70.0645 15.1063 70.1374 14.8887ZM79.6876 10.2472H77.2818C77.2089 10.2472 77.136 10.3197 77.0631 10.3922C76.9902 10.4648 76.9902 10.5373 76.9902 10.6098V11.7702C76.5528 11.19 75.8967 10.6823 75.2406 10.3922C74.4386 10.1021 73.6367 9.9571 72.7619 9.9571C71.6684 9.9571 70.6477 10.1747 69.7 10.6823C68.8252 11.1175 68.1691 11.8427 67.6587 12.713C67.1484 13.5833 66.9297 14.5986 66.9297 15.6139C66.9297 16.5567 67.1484 17.4995 67.5129 18.3698L67.6587 18.5148C68.0962 19.3126 68.8252 19.9653 69.6271 20.473C69.9916 20.6905 70.429 20.8356 70.8664 20.9806C71.3768 21.1257 71.8871 21.1982 72.4703 21.1257C73.0535 21.1257 73.6367 21.0532 74.2199 20.9806C74.5115 20.9081 74.8031 20.7631 75.0947 20.6905C75.8238 20.4004 76.4799 19.8928 76.9902 19.3126V21.0532C76.9902 21.5608 76.8444 22.0685 76.5528 22.5036C76.2612 22.9388 75.8238 23.3014 75.3135 23.5189C74.9489 23.664 74.5844 23.809 74.2199 23.809C73.9283 23.809 73.7096 23.8816 73.418 23.8816C71.8142 23.8816 70.7935 23.4464 70.2832 22.5036C70.2832 22.4311 70.2103 22.3586 70.1374 22.3586H67.5858C67.44 22.3586 67.2942 22.5036 67.2942 22.6487V22.7212C67.5858 23.809 68.242 24.6793 69.1897 25.332C70.5019 26.0573 71.96 26.3473 73.4909 26.2748C74.6573 26.3473 75.8238 26.0572 76.9173 25.6221C76.9902 25.6221 76.9902 25.5496 77.0631 25.5496C77.5734 25.332 78.0108 25.0419 78.3753 24.6793C79.396 23.7365 79.9792 22.4311 80.0521 21.0532C80.125 20.618 80.125 20.1829 80.125 19.8203V10.6098C80.0521 10.3922 79.9063 10.2472 79.6876 10.2472ZM130.427 16.1216C130.427 16.9193 130.136 17.7171 129.553 18.2247C129.261 18.5148 128.824 18.8049 128.386 18.95C127.949 19.095 127.438 19.2401 127.001 19.2401C126.126 19.3126 125.178 18.95 124.595 18.3698C123.939 17.7171 123.648 16.7743 123.72 15.8315C123.648 14.8887 123.939 13.9459 124.595 13.2206C125.324 12.5679 126.199 12.2778 127.147 12.3504C128.022 12.2778 128.969 12.6405 129.553 13.2206C129.844 13.5107 130.063 13.8734 130.209 14.236C130.354 14.6711 130.427 15.0337 130.427 15.4689V16.1216ZM133.198 6.25842H130.719C130.646 6.25842 130.573 6.25842 130.5 6.33094C130.427 6.40347 130.427 6.47599 130.427 6.54852V11.6251C129.407 10.3922 127.876 9.73954 126.272 9.81206C125.178 9.81206 124.158 10.0296 123.21 10.6098C122.335 11.1175 121.606 11.8427 121.169 12.713C120.659 13.6558 120.44 14.7436 120.513 15.8315C120.513 16.9193 120.731 17.9347 121.169 18.8775C121.606 19.7477 122.262 20.4004 123.137 20.9081C124.012 21.4158 124.96 21.6333 125.98 21.6333C126.928 21.6333 127.803 21.4883 128.605 21.1257C129.407 20.8356 130.063 20.2554 130.5 19.6027V20.9806C130.5 21.1982 130.646 21.3432 130.865 21.3432H133.271C133.489 21.3432 133.635 21.1982 133.635 20.9806V6.62104C133.635 6.54852 133.635 6.40347 133.562 6.40347C133.416 6.33095 133.343 6.25842 133.198 6.25842ZM108.921 14.5986C108.994 13.8734 109.359 13.2206 109.942 12.858C110.598 12.3504 111.4 12.1328 112.202 12.1328C113.077 12.0603 113.879 12.2778 114.608 12.7855C115.191 13.2206 115.555 13.8734 115.482 14.5986H108.921ZM116.941 11.4076C115.628 10.3922 113.952 9.81206 112.275 9.9571C111.108 9.9571 109.942 10.1747 108.848 10.7549C107.901 11.2625 107.099 11.9878 106.588 12.9306C106.078 13.8734 105.787 14.9612 105.787 16.0491C105.714 17.6446 106.297 19.1676 107.463 20.2554C108.775 21.3432 110.452 21.8509 112.202 21.7784C113.66 21.8509 115.118 21.5608 116.43 20.8356C117.378 20.2554 118.034 19.3851 118.326 18.2973C118.399 18.1522 118.326 18.0072 118.18 18.0072H115.628C115.555 18.0072 115.41 18.0797 115.41 18.1522C114.972 19.0225 113.952 19.5302 112.421 19.5302C111.837 19.5302 111.181 19.3851 110.598 19.1676C110.088 18.95 109.723 18.5874 109.359 18.1522C109.067 17.7171 108.921 17.2094 108.921 16.7018H118.18C118.326 16.7018 118.399 16.6292 118.471 16.5567C118.544 16.4842 118.617 16.3391 118.617 16.2666V15.6864C118.69 14.0909 118.034 12.5679 116.941 11.4076ZM94.4138 14.5986C94.4867 13.8734 94.8512 13.2206 95.4344 12.858C96.0905 12.3504 96.8925 12.1328 97.6944 12.1328C98.5692 12.0603 99.3711 12.2778 100.1 12.7855C100.683 13.2206 101.048 13.8734 100.975 14.5986H94.4138ZM102.36 11.4076C101.048 10.3922 99.3711 9.81206 97.6944 9.9571C96.5279 9.9571 95.3615 10.1747 94.268 10.7549C93.3203 11.2625 92.5183 11.9878 92.008 12.9306C91.4977 13.8734 91.2061 14.9612 91.2061 16.0491C91.1332 17.6446 91.7164 19.1676 92.8829 20.2554C94.1951 21.3432 95.8718 21.8509 97.6215 21.7784C99.0795 21.8509 100.538 21.5608 101.85 20.8356C102.798 20.2554 103.454 19.3851 103.745 18.2973C103.818 18.1522 103.745 18.0072 103.599 18.0072H101.048C100.975 18.0072 100.829 18.0797 100.829 18.1522C100.392 19.0225 99.3711 19.5302 97.8402 19.5302C97.257 19.5302 96.6009 19.3851 96.0176 19.1676C95.5073 18.95 95.1428 18.5874 94.7783 18.1522C94.4867 17.7171 94.3409 17.2094 94.3409 16.7018H103.599C103.745 16.7018 103.818 16.6292 103.891 16.5567C103.964 16.4842 104.037 16.3391 104.037 16.2666V15.6864C104.11 14.0909 103.527 12.5679 102.36 11.4076ZM89.8939 10.1022C88.29 10.1022 86.832 10.8274 85.8114 12.0603V10.6098C85.8114 10.5373 85.8114 10.4648 85.7384 10.3922C85.6655 10.3197 85.5926 10.3197 85.5197 10.2472H83.114C82.8953 10.2472 82.7495 10.3922 82.7495 10.6098V21.0532C82.7495 21.2707 82.8953 21.4158 83.114 21.4158H85.5926C85.8114 21.4158 85.9572 21.2707 85.9572 21.0532V15.5414C85.9572 14.8162 86.3217 14.0909 86.9049 13.5833C87.6339 13.0031 88.5816 12.6405 89.5294 12.713H89.9668C90.1855 12.713 90.4042 12.5679 90.4042 12.3504V10.4648C90.4042 10.3922 90.3313 10.2472 90.2584 10.1747C90.1855 10.1022 90.1126 10.0296 89.9668 10.0296H89.8939V10.1022ZM55.4112 14.6711C55.4841 13.9459 55.8486 13.2932 56.4318 12.9306C57.0879 12.4229 57.8899 12.2053 58.6918 12.2053C59.5666 12.1328 60.3685 12.3504 61.0976 12.858C61.6808 13.2932 61.9724 13.9459 61.9724 14.6711H55.4112ZM63.4304 11.4076C62.1182 10.3197 60.5143 9.81206 58.8376 9.88458C57.6712 9.88458 56.5047 10.1022 55.4112 10.6823C54.4635 11.19 53.6616 11.9152 53.1512 12.858C52.6409 13.8008 52.3493 14.8887 52.3493 15.9765C52.2764 17.572 52.8596 19.095 54.0261 20.1829C55.3383 21.2707 57.015 21.7784 58.7647 21.7059C60.2227 21.7784 61.6808 21.4883 62.993 20.7631C63.9407 20.1829 64.5969 19.3126 64.8885 18.2247C64.9614 18.0797 64.8156 17.9347 64.7427 17.9347H62.1911C62.1182 17.9347 61.9724 18.0072 61.9724 18.0797C61.535 18.95 60.5143 19.4576 58.9105 19.4576C58.3273 19.4576 57.6712 19.3126 57.0879 19.095C56.5776 18.8775 56.2131 18.5148 55.8486 18.0797C55.557 17.6446 55.4112 17.1369 55.4112 16.6292H64.5969C64.7427 16.6292 64.8156 16.5567 64.8885 16.4842C64.9614 16.4117 65.0343 16.2666 65.0343 16.1941V15.6864C65.1072 14.0909 64.524 12.5679 63.4304 11.4076ZM47.1733 16.1216C47.1733 16.4842 47.1004 16.9193 46.9546 17.2819C46.8088 17.6446 46.5901 18.0072 46.2984 18.2973C46.0068 18.5874 45.5694 18.8775 45.132 19.0225C44.6946 19.1675 44.1843 19.3126 43.674 19.3126C42.7991 19.3851 41.8514 19.0225 41.2682 18.4423C40.6121 17.7896 40.3205 16.8468 40.3934 15.9765C40.3205 15.0337 40.6121 14.0909 41.2682 13.3657C41.9972 12.713 42.872 12.4229 43.8198 12.4954C44.6946 12.4229 45.6423 12.7855 46.2255 13.3657C46.5172 13.6558 46.7359 14.0184 46.8817 14.381C47.0275 14.7436 47.1004 15.1788 47.1004 15.6139L47.1733 16.1216ZM49.9435 6.33094H47.4649C47.2462 6.33094 47.1004 6.47599 47.1004 6.69356V11.7702C46.0797 10.5373 44.4759 9.88458 42.872 9.9571C41.7785 9.9571 40.7579 10.1747 39.8102 10.7549C38.9353 11.2625 38.2063 11.9878 37.7689 12.858C36.8212 14.8162 36.8212 17.0644 37.7689 19.0225C38.2063 19.8928 38.8624 20.5455 39.7373 21.0532C40.6121 21.5608 41.5598 21.7784 42.5804 21.7784C43.5282 21.7784 44.403 21.6333 45.2049 21.2707C46.0068 20.9806 46.663 20.4004 47.1004 19.7477V21.1257C47.1004 21.3432 47.2462 21.4883 47.4649 21.4883H49.8706C50.0894 21.4883 50.2352 21.3432 50.2352 21.1257V6.69356C50.2352 6.62104 50.1622 6.54852 50.1622 6.47599C50.1622 6.33095 50.0164 6.33094 49.9435 6.33094Z' fill='%23353C42'/%3E%3C/svg%3E",
        "altText": "Degreed logo"
      },
      "colors": {
        "background": "#ffffff",
        "text": "var(--apollo-color-neutral-800)",
        "highlight": "var(--apollo-color-primary-800)",
        "separator": "var(--apollo-color-neutral-200)"
      },
      "text": "Degreed Logo",
      "analytics": "global.navigation.learner.brand",
      "i18n": "global.navigation.learner.brand",
      "dgat": "global.navigation.learner.brand"
    },
    "features": {
      "search": {
        "enabled": true,
        "visible": true,
        "text": "Search",
        "i18n": "global.navigation.learner.features.search, Core_Search",
        "dgat": "global.navigation.learner.features.search",
        "analytics": "global.navigation.learner.features.search"
      },
      "addContent": {
        "enabled": true,
        "visible": true,
        "text": "Add",
        "i18n": "global.navigation.learner.features.add-content, Core_Add",
        "titleText": "Add to Profile",
        "titleI18n": "global.navigation.learner.features.add-to-profile, dgTagRating_AddToProfile",
        "dgat": "global.navigation.learner.features.add-content",
        "analytics": "global.navigation.learner.features.add-content"
      },
      "beta": {
        "enabled": true,
        "visible": true,
        "text": "Beta",
        "i18n": "global.navigation.learner.features.beta",
        "dgat": "global.navigation.learner.features.beta"
      },
      "footerBranding": {
        "enabled": true,
        "visible": true,
        "text": "Powered by",
        "i18n": "global.navigation.learner.features.footer-branding, Core_PoweredBy",
        "dgat": "global.navigation.learner.features.footer-branding"
      },
      "sidebarBranding": {
        "enabled": true,
        "visible": true,
        "text": "Powered by",
        "i18n": "global.navigation.learner.features.sidebar-branding, Core_PoweredBy",
        "dgat": "global.navigation.learner.features.sidebar-branding"
      },
      "switcher": {
        "enabled": true,
        "visible": true,
        "text": "Show Admin View",
        "i18n": "global.navigation.learner.features.show-admin-view",
        "dgat": "global.navigation.learner.features.show-admin-view",
        "analytics": "global.navigation.learner.features.show-admin-view",
        "href": "/orgs/<orgId>"
      },
      "extendedEnterprise": {
        "enabled": true,
        "visible": true,
        "text": "Extended Enterprise",
        "i18n": "global.navigation.learner.features.extended-enterprise",
        "dgat": "global.navigation.learner.features.extended-enterprise",
        "analytics": "global.navigation.learner.features.extended-enterprise",
        "href": "/channel",
        "blocksWhileImpersonating": true
      },
      "logOut": {
        "enabled": true,
        "visible": true,
        "text": "Log Out",
        "i18n": "global.navigation.logout",
        "dgat": "global.leaner.navigation.logout",
        "analytics": "global.navigation.logout",
        "href": "/account/logoff"
      }
    },
    "navigation": {
      "top": [
        {
          "headerTitle": "Home",
          "headerTitleI18n": "AppHeader_HomeTitle, Core_Home",
          "text": "Home",
          "i18n": "global.navigation.learner.sidebar.home, Core_Home",
          "dgat": "global.navigation.learner.sidebar.home",
          "analytics": "global.navigation.learner.sidebar.home",
          "icon": "home",
          "routerLink": "/<user>/home/overview",
          "children": [
            {
              "text": "Overview",
              "i18n": "global.navigation.learner.sidebar.home.overview",
              "dgat": "global.navigation.learner.sidebar.home.overview",
              "analytics": "global.navigation.learner.sidebar.home.overview",
              "routerLink": "/<user>/home/overview"
            },
            {
              "text": "Assignments",
              "i18n": "global.navigation.learner.sidebar.home.assignments, DashboardNav_Assignments",
              "dgat": "global.navigation.learner.sidebar.home.assignments",
              "analytics": "global.navigation.learner.sidebar.home.assignments",
              "routerLink": "/<user>/home/assignments"
            },
            {
              "text": "Saved",
              "i18n": "global.navigation.learner.sidebar.home.saved, Core_Saved",
              "dgat": "global.navigation.learner.sidebar.home.saved",
              "analytics": "global.navigation.learner.sidebar.home.saved",
              "routerLink": "/<user>/home/saved"
            },
            {
              "text": "Shared",
              "i18n": "global.navigation.learner.sidebar.home.shared, Core_Shared",
              "dgat": "global.navigation.learner.sidebar.home.shared",
              "analytics": "global.navigation.learner.sidebar.home.shared",
              "routerLink": "/<user>/home/shared"
            },
            {
              "text": "Pathways",
              "i18n": "global.navigation.learner.sidebar.home.pathways, Core_Pathways",
              "dgat": "global.navigation.learner.sidebar.home.pathways",
              "analytics": "global.navigation.learner.sidebar.home.pathways",
              "routerLink": "/<user>/home/pathways"
            },
            {
              "text": "Plans",
              "i18n": "global.navigation.learner.sidebar.home.plans, Core_Plans",
              "dgat": "global.navigation.learner.sidebar.home.plans",
              "analytics": "global.navigation.learner.sidebar.home.plans",
              "routerLink": "/<user>/home/plans"
            },
            {
              "text": "Groups",
              "i18n": "global.navigation.learner.sidebar.home.groups, Core_Groups",
              "dgat": "global.navigation.learner.sidebar.home.groups",
              "analytics": "global.navigation.learner.sidebar.home.groups",
              "routerLink": "/<user>/home/groups"
            },
            {
              "text": "Pages",
              "i18n": "global.navigation.learner.sidebar.home.pages, Core_Pages",
              "dgat": "global.navigation.learner.sidebar.home.pages",
              "analytics": "global.navigation.learner.sidebar.home.pages",
              "routerLink": "/pages",
              "end": true
            }
          ]
        },
        {
          "headerTitle": "Featured",
          "headerTitleI18n": "global.navigation.learner.sidebar.featured, AppHeader_FeaturedTitle",
          "text": "Featured",
          "i18n": "global.navigation.learner.sidebar.featured, AppHeader_FeaturedTitle",
          "dgat": "global.navigation.learner.sidebar.featured",
          "icon": "megaphone",
          "analytics": "global.navigation.learner.sidebar.featured",
          "routerLink": "/explore/<featuredPlanId>"
        },
        {
          "headerTitle": "Discover",
          "headerTitleI18n": "global.navigation.learner.sidebar.discover, Core_Discover",
          "text": "Discover",
          "i18n": "global.navigation.learner.sidebar.discover, Core_Discover",
          "dgat": "global.navigation.learner.sidebar.discover",
          "icon": "magnifying-glass",
          "rtlMirrorIcon": true,
          "analytics": "global.navigation.learner.sidebar.discover",
          "routerLink": "/learning/search",
          "suppressesSearch": true
        },
        {
          "headerTitle": "Skill Coach",
          "headerTitleI18n": "global.navigation.learner.sidebar.skill-coach, AppHeader_SkillCoachTitle, , Core_SkillCoach",
          "text": "Skill Coach",
          "i18n": "global.navigation.learner.sidebar.skill-coach, Core_SkillCoach",
          "dgat": "global.navigation.learner.sidebar.skill-coach",
          "icon": "user-group",
          "analytics": "global.navigation.learner.sidebar.skill-coach",
          "routerLink": "/team/members",
          "children": [
            {
              "text": "Members",
              "i18n": "global.navigation.learner.sidebar.skill-coach.members, Core_Members",
              "dgat": "global.navigation.learner.sidebar.skill-coach.members",
              "analytics": "global.navigation.learner.sidebar.skill-coach.members",
              "routerLink": "/team/members"
            },
            {
              "text": "Team Skills",
              "i18n": "global.navigation.learner.sidebar.skill-coach.team-skills, Team_Skills",
              "dgat": "global.navigation.learner.sidebar.skill-coach.team-skills",
              "analytics": "global.navigation.learner.sidebar.skill-coach.team-skills",
              "routerLink": "/team/skills"
            },
            {
              "text": "Assignments",
              "i18n": "global.navigation.learner.sidebar.skill-coach.assignments, Team_Assignments",
              "dgat": "global.navigation.learner.sidebar.skill-coach.assignments",
              "analytics": "global.navigation.learner.sidebar.skill-coach.assignments",
              "routerLink": "/team/assignments"
            },
            {
              "text": "Learning Insights",
              "i18n": "global.navigation.learner.sidebar.skill-coach.learning-insights, Team_LearningInsights",
              "dgat": "global.navigation.learner.sidebar.skill-coach.learning-insights",
              "analytics": "global.navigation.learner.sidebar.skill-coach.learning-insights",
              "routerLink": "/team/learningInsights"
            },
            {
              "text": "Skill Insights",
              "i18n": "global.navigation.learner.sidebar.skill-coach.skill-insights, Team_SkillInsights",
              "dgat": "global.navigation.learner.sidebar.skill-coach.skill-insights",
              "analytics": "global.navigation.learner.sidebar.skill-coach.skill-insights",
              "routerLink": "/team/skillInsights"
            }
          ]
        },
        {
          "headerTitle": "Maestro",
          "headerTitleI18n": "global.navigation.learner.sidebar.maestro, AppHeader_MaestroTitle",
          "text": "Maestro",
          "i18n": "global.navigation.learner.sidebar.maestro, AppHeader_MaestroTitle",
          "dgat": "global.navigation.learner.sidebar.maestro",
          "icon": "sparkles",
          "analytics": "global.navigation.learner.sidebar.maestro",
          "routerLink": "/maestro",
          "children": [
            {
              "text": "Quick Actions",
              "i18n": "global.navigation.learner.sidebar.maestro.quickactions, Coach_QuickActions",
              "dgat": "global.navigation.learner.sidebar.maestro.quickactions",
              "analytics": "global.navigation.learner.sidebar.maestro.quickactions",
              "routerLink": "/maestro",
              "end": true
            },
            {
              "text": "Ask Maestro",
              "i18n": "global.navigation.learner.sidebar.maestro.askmaestro, Maestro_AskNavTitle",
              "dgat": "global.navigation.learner.sidebar.maestro.askmaestro",
              "analytics": "global.navigation.learner.sidebar.maestro.askmaestro",
              "routerLink": "/maestro/ask-maestro",
              "end": true
            },
            {
              "text": "Maestro",
              "i18n": "global.navigation.learner.sidebar.maestro.newmaestro, Maestro_NewNavTitle",
              "dgat": "global.navigation.learner.sidebar.maestro.newmaestro",
              "analytics": "global.navigation.learner.sidebar.maestro.newmaestro",
              "routerLink": "/maestro/new-maestro",
              "end": true
            },
            {
              "text": "Browse Experiences",
              "i18n": "global.navigation.learner.sidebar.maestro.browseexperiences, Coach_BrowseExperiences",
              "dgat": "global.navigation.learner.sidebar.maestro.browseexperiences",
              "analytics": "global.navigation.learner.sidebar.maestro.browseexperiences",
              "routerLink": "/maestro/experiences"
            }
          ]
        },
        {
          "headerTitle": "Opportunities",
          "headerTitleI18n": "global.navigation.learner.sidebar.opportunities, AppHeader_OpportunitiesTitle, Core_Opportunities",
          "text": "Opportunities",
          "i18n": "global.navigation.learner.sidebar.opportunities, Core_Opportunities",
          "dgat": "global.navigation.learner.sidebar.opportunities",
          "analytics": "global.navigation.learner.sidebar.opportunities",
          "icon": "briefcase",
          "routerLink": "/career/opportunities/marketplace",
          "children": [
            {
              "text": "Marketplace",
              "i18n": "global.navigation.learner.sidebar.opportunities.marketplace, Opportunities_Marketplace",
              "dgat": "global.navigation.learner.sidebar.opportunities.marketplace",
              "analytics": "global.navigation.learner.sidebar.opportunities.marketplace",
              "routerLink": "/career/opportunities/marketplace"
            },
            {
              "text": "Browse",
              "i18n": "global.navigation.learner.sidebar.opportunities.browse, Core_Browse",
              "dgat": "global.navigation.learner.sidebar.opportunities.browse",
              "analytics": "global.navigation.learner.sidebar.opportunities.browse",
              "routerLink": "/career/opportunities/browse"
            },
            {
              "text": "Mentoring",
              "i18n": "global.navigation.learner.sidebar.opportunities.mentoring, Opportunities_Mentoring",
              "dgat": "global.navigation.learner.sidebar.opportunities.mentoring",
              "analytics": "global.navigation.learner.sidebar.opportunities.mentoring",
              "routerLink": "/career/opportunities/mentoring"
            },
            {
              "text": "Open Insights",
              "i18n": "global.navigation.learner.sidebar.opportunities.open-insights, OrgOpportunity_OpenInsights_Tab",
              "dgat": "global.navigation.learner.sidebar.opportunities.open-insights",
              "analytics": "global.navigation.learner.sidebar.opportunities.open-insights",
              "routerLink": "/career/opportunities/open-insights"
            },
            {
              "text": "Engagement Insights",
              "i18n": "global.navigation.learner.sidebar.opportunities.engagement-insights, OrgOpportunity_EngagementInsights_Tab",
              "dgat": "global.navigation.learner.sidebar.opportunities.engagement-insights",
              "analytics": "global.navigation.learner.sidebar.opportunities.engagement-insights",
              "routerLink": "/career/opportunities/engagement-insights"
            },
            {
              "text": "Positions",
              "i18n": "Core_JobPositionPlural",
              "dgat": "global.navigation.learner.sidebar.opportunities.job-positions",
              "analytics": "global.navigation.learner.sidebar.opportunities.job-positions",
              "routerLink": "/career/opportunities/positions"
            }
          ]
        },
        {
          "headerTitle": "Notifications",
          "headerTitleI18n": "global.navigation.learner.sidebar.notifications, User_Notifications",
          "text": "Notifications",
          "i18n": "global.navigation.learner.sidebar.notifications, User_Notifications",
          "dgat": "global.navigation.learner.sidebar.notifications",
          "analytics": "global.navigation.learner.sidebar.notifications",
          "icon": "bell",
          "routerLink": "/notifications",
          "badge": "notification",
          "badgeI18n": "NotificationFeedCtrl_NewNotifications"
        },
        {
          "headerTitle": "Profile",
          "headerTitleI18n": "global.navigation.learner.sidebar.profile, AppHeader_ProfileTitle",
          "text": "Profile",
          "i18n": "global.navigation.learner.sidebar.profile, AppHeader_ProfileTitle",
          "dgat": "global.navigation.learner.sidebar.profile",
          "analytics": "global.navigation.learner.sidebar.profile",
          "image": "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='23' height='23' rx='11.5' fill='%23F4F6F7'/%3E%3Crect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='%23E2E8EB'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.75 9C9.75 7.75736 10.7574 6.75 12 6.75C13.2426 6.75 14.25 7.75736 14.25 9C14.25 10.2426 13.2426 11.25 12 11.25C10.7574 11.25 9.75 10.2426 9.75 9Z' fill='%235B737F'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.87562 16.0527C7.91429 13.8078 9.74599 12 12 12C14.2541 12 16.0858 13.8079 16.1244 16.0528C16.1269 16.2017 16.0412 16.338 15.9058 16.4001C14.7164 16.9459 13.3933 17.25 12.0002 17.25C10.6069 17.25 9.28372 16.9458 8.09416 16.3999C7.95883 16.3378 7.87306 16.2015 7.87562 16.0527Z' fill='%235B737F'/%3E%3C/svg%3E%0A",
          "routerLink": "/profile/<user>/overview",
          "children": [
            {
              "text": "Overview",
              "i18n": "global.navigation.learner.sidebar.profile.overview, UserController_Profile",
              "dgat": "global.navigation.learner.sidebar.profile.overview",
              "analytics": "global.navigation.learner.sidebar.profile.overview",
              "routerLink": "/profile/<user>/overview"
            },
            {
              "text": "Skills",
              "i18n": "global.navigation.learner.sidebar.profile.skills, UserController_Skills",
              "dgat": "global.navigation.learner.sidebar.profile.skills",
              "analytics": "global.navigation.learner.sidebar.profile.skills",
              "routerLink": "/profile/<user>/skills"
            },
            {
              "text": "Collection",
              "i18n": "global.navigation.learner.sidebar.profile.collection, UserController_Collection",
              "dgat": "global.navigation.learner.sidebar.profile.collection",
              "analytics": "global.navigation.learner.sidebar.profile.collection",
              "routerLink": "/profile/<user>/collection"
            },
            {
              "text": "Activity",
              "i18n": "global.navigation.learner.sidebar.profile.activity, Core_Activity",
              "dgat": "global.navigation.learner.sidebar.profile.activity",
              "analytics": "global.navigation.learner.sidebar.profile.activity",
              "routerLink": "/profile/<user>/insights"
            },
            {
              "text": "Skill Ratings",
              "headerTitle": "Profile",
              "headerTitleI18n": "User_Profile",
              "i18n": "global.navigation.learner.sidebar.profile.skill-ratings, Core_SkillRatings",
              "dgat": "global.navigation.learner.sidebar.profile.skill-ratings",
              "analytics": "global.navigation.learner.sidebar.profile.skill-ratings",
              "routerLink": "/profile/<user>/skill-ratings",
              "visible": false
            },
            {
              "text": "Settings",
              "i18n": "global.navigation.learner.sidebar.profile.settings, Core_Settings",
              "dgat": "global.navigation.learner.sidebar.profile.settings",
              "analytics": "global.navigation.learner.sidebar.profile.settings",
              "routerLink": "/profile/<user>/settings"
            },
            {
              "text": "My Plan",
              "i18n": "global.navigation.learner.sidebar.profile.my-plan",
              "dgat": "global.navigation.learner.sidebar.profile.my-plan",
              "analytics": "global.navigation.learner.sidebar.profile.my-plan",
              "href": "<learnInSSOUrl>",
              "target": "_blank"
            }
          ]
        },
        {
          "headerTitle": "Help",
          "headerTitleI18n": "global.navigation.learner.sidebar.help, Core_Help",
          "text": "Help",
          "i18n": "global.navigation.learner.sidebar.help, Core_Help",
          "dgat": "global.navigation.learner.sidebar.help",
          "analytics": "global.navigation.learner.sidebar.help",
          "icon": "lifebuoy",
          "href": null,
          "target": "_self",
          "children": [
            {
              "text": "Knowledge Center",
              "i18n": "global.navigation.learner.sidebar.help.knowledge-center, FeedbackPartial_KnowledgeCenter",
              "dgat": "global.navigation.learner.sidebar.help.knowledge-center",
              "analytics": "global.navigation.learner.sidebar.help.knowledge-center",
              "href": "#",
              "target": "_blank"
            },
            {
              "text": "Privacy Policy",
              "i18n": "global.navigation.learner.sidebar.help.privacy-policy, FeedbackPartial_PrivacyPolicy",
              "dgat": "global.navigation.learner.sidebar.help.privacy-policy",
              "analytics": "global.navigation.learner.sidebar.help.privacy-policy",
              "href": "/about/privacy",
              "target": "_blank"
            },
            {
              "text": "Cookie Notice",
              "i18n": "global.navigation.learner.sidebar.help.cookie-notice, OrgSettings_ShowCookiePolicyLink_Name",
              "dgat": "global.navigation.learner.sidebar.help.cookie-notice",
              "analytics": "global.navigation.learner.sidebar.help.cookie-notice",
              "href": "/api/about/cookienotice",
              "target": "_blank"
            },
            {
              "text": "Frequently Asked Questions",
              "i18n": "global.navigation.learner.sidebar.help.faq, OrgSettings_OrgSupportInfoFaq_Name",
              "dgat": "global.navigation.learner.sidebar.help.faq",
              "analytics": "global.navigation.learner.sidebar.help.faq",
              "href": "/faq/<orgId>",
              "target": "_blank",
              "includeSeparator": true
            },
            {
              "text": "",
              "dgat": "global.navigation.learner.sidebar.help.custom-link",
              "analytics": "global.navigation.learner.sidebar.help.custom-link",
              "href": "#",
              "target": "_blank"
            },
            {
              "text": "",
              "dgat": "global.navigation.learner.sidebar.help.support-phone",
              "analytics": "global.navigation.learner.sidebar.help.support-phone",
              "icon": "phone",
              "href": "#",
              "includeSeparator": true
            },
            {
              "text": "",
              "dgat": "global.navigation.learner.sidebar.help.support-email",
              "analytics": "global.navigation.learner.sidebar.help.support-email",
              "icon": "envelope",
              "href": "#"
            }
          ]
        }
      ],
      "bottom": []
    }
  },
  "admin": {
    "brand": {
      "routerLink": "/orgs/<orgId>",
      "mark": {
        "url": "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='%230062E3' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath class='logo' fill-rule='evenodd' clip-rule='evenodd' d='M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z' /%3E%3C/svg%3E",
        "altText": "Degreed logo"
      },
      "logo": {
        "url": "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='268' height='54' viewBox='0 0 134 27' fill='none'%3E%3Cpath d='M27.344 18.1522C26.3963 18.9499 25.2299 19.4576 23.9176 19.4576C22.0222 19.5301 20.7099 19.3125 19.9809 17.717C18.8874 15.4688 19.4706 14.0909 19.5435 13.8733C20.4183 12.1327 27.1253 11.6976 27.7814 13.0756C28.2188 13.8008 28.3647 17.1369 27.344 18.1522ZM11.6701 17.717C10.9411 19.3125 9.62883 19.5301 7.73337 19.4576C6.49404 19.4576 5.2547 19.0225 4.30698 18.1522C3.35925 17.0643 3.43215 13.8008 3.79666 13.0756C4.52568 11.6976 11.1598 12.1327 12.0346 13.8733C12.1804 14.0909 12.7636 15.4688 11.6701 17.717ZM30.9162 10.6098L21.2932 5.38809L21.0015 5.17052C20.4183 4.95295 19.8351 4.95295 19.3248 5.17052L18.9603 5.38809L17.4293 6.25837V6.33089L18.0126 6.62099L21.6577 8.57911L23.7718 9.73949C21.6577 9.88453 19.5435 10.5372 17.721 11.5526C17.2106 11.8427 16.5545 12.0602 15.9713 12.0602H15.8255C15.1694 12.0602 14.5862 11.9152 14.0759 11.5526C12.1804 10.5372 10.1391 9.88453 8.02498 9.73949L15.8984 5.38809L18.7416 3.79258C19.4706 3.28492 20.3454 3.13987 21.2203 3.35744C21.9493 3.64754 22.6054 3.93763 23.2615 4.37277C23.5531 4.51782 23.8447 4.59034 24.1363 4.51781C24.4279 4.44529 24.6466 4.30025 24.8654 4.08268C25.0841 3.86511 25.157 3.50249 25.157 3.2124C25.157 2.77726 24.9383 2.34212 24.5008 2.05203C23.5531 1.39932 22.4596 0.964178 21.2932 0.674086C18.6687 0.238946 16.9919 1.47184 15.7526 2.19707C14.2217 0.96418 12.1804 0.383993 10.212 0.674086C9.04561 0.964178 8.02498 1.39932 7.00435 2.05203C6.42114 2.48717 6.20243 3.28492 6.63984 3.86511C6.63984 3.93763 6.71274 3.93763 6.71274 4.01015C7.00435 4.30025 7.36886 4.44529 7.73337 4.44529C7.95208 4.44529 8.17079 4.37277 8.38949 4.22772C9.04561 3.86511 9.70173 3.50249 10.4307 3.2124C11.3056 2.99483 12.2533 3.2124 12.9823 3.72006L0.807678 10.6098C0.51607 10.7548 0.297363 11.1174 0.297363 11.48V13.1481C0.297363 13.5107 0.51607 13.8733 0.807678 14.0183C1.09929 14.1634 1.17219 14.3084 1.17219 14.8886C1.17219 15.9765 0.443168 21.7783 8.09788 21.7783C14.9507 21.7783 14.1488 15.1062 15.8255 15.1062C17.5022 15.1062 16.7003 21.7783 23.5531 21.7783C31.2078 21.7783 30.4788 15.9765 30.4788 14.8886C30.4788 14.3084 30.5517 14.1634 30.8433 14.0183C31.2078 13.8733 31.4265 13.5107 31.4265 13.1481V11.48C31.4994 11.1174 31.2807 10.7548 30.9162 10.6098Z' fill='%230062E3'/%3E%3Cpath d='M70.1374 14.8887C70.2103 14.236 70.5019 13.6558 71.0122 13.2206C71.7413 12.6405 72.6161 12.3504 73.5638 12.4229C74.4386 12.3504 75.3135 12.6405 75.9696 13.2206C76.4799 13.6558 76.7715 14.3085 76.8444 14.9612V15.759C76.8444 16.4117 76.6257 17.0644 76.1883 17.572C76.1154 17.6446 76.0425 17.7896 75.8967 17.8621C75.6051 18.1522 75.1677 18.3698 74.8031 18.5148C74.3657 18.6599 73.8554 18.7324 73.3451 18.7324C72.4703 18.8049 71.5954 18.5148 70.9393 17.8621C70.8664 17.7896 70.7206 17.7171 70.6477 17.572C70.2103 16.9919 69.9916 16.2666 70.0645 15.5414C70.0645 15.3238 70.0645 15.1063 70.1374 14.8887ZM79.6876 10.2472H77.2818C77.2089 10.2472 77.136 10.3197 77.0631 10.3922C76.9902 10.4648 76.9902 10.5373 76.9902 10.6098V11.7702C76.5528 11.19 75.8967 10.6823 75.2406 10.3922C74.4386 10.1021 73.6367 9.9571 72.7619 9.9571C71.6684 9.9571 70.6477 10.1747 69.7 10.6823C68.8252 11.1175 68.1691 11.8427 67.6587 12.713C67.1484 13.5833 66.9297 14.5986 66.9297 15.6139C66.9297 16.5567 67.1484 17.4995 67.5129 18.3698L67.6587 18.5148C68.0962 19.3126 68.8252 19.9653 69.6271 20.473C69.9916 20.6905 70.429 20.8356 70.8664 20.9806C71.3768 21.1257 71.8871 21.1982 72.4703 21.1257C73.0535 21.1257 73.6367 21.0532 74.2199 20.9806C74.5115 20.9081 74.8031 20.7631 75.0947 20.6905C75.8238 20.4004 76.4799 19.8928 76.9902 19.3126V21.0532C76.9902 21.5608 76.8444 22.0685 76.5528 22.5036C76.2612 22.9388 75.8238 23.3014 75.3135 23.5189C74.9489 23.664 74.5844 23.809 74.2199 23.809C73.9283 23.809 73.7096 23.8816 73.418 23.8816C71.8142 23.8816 70.7935 23.4464 70.2832 22.5036C70.2832 22.4311 70.2103 22.3586 70.1374 22.3586H67.5858C67.44 22.3586 67.2942 22.5036 67.2942 22.6487V22.7212C67.5858 23.809 68.242 24.6793 69.1897 25.332C70.5019 26.0573 71.96 26.3473 73.4909 26.2748C74.6573 26.3473 75.8238 26.0572 76.9173 25.6221C76.9902 25.6221 76.9902 25.5496 77.0631 25.5496C77.5734 25.332 78.0108 25.0419 78.3753 24.6793C79.396 23.7365 79.9792 22.4311 80.0521 21.0532C80.125 20.618 80.125 20.1829 80.125 19.8203V10.6098C80.0521 10.3922 79.9063 10.2472 79.6876 10.2472ZM130.427 16.1216C130.427 16.9193 130.136 17.7171 129.553 18.2247C129.261 18.5148 128.824 18.8049 128.386 18.95C127.949 19.095 127.438 19.2401 127.001 19.2401C126.126 19.3126 125.178 18.95 124.595 18.3698C123.939 17.7171 123.648 16.7743 123.72 15.8315C123.648 14.8887 123.939 13.9459 124.595 13.2206C125.324 12.5679 126.199 12.2778 127.147 12.3504C128.022 12.2778 128.969 12.6405 129.553 13.2206C129.844 13.5107 130.063 13.8734 130.209 14.236C130.354 14.6711 130.427 15.0337 130.427 15.4689V16.1216ZM133.198 6.25842H130.719C130.646 6.25842 130.573 6.25842 130.5 6.33094C130.427 6.40347 130.427 6.47599 130.427 6.54852V11.6251C129.407 10.3922 127.876 9.73954 126.272 9.81206C125.178 9.81206 124.158 10.0296 123.21 10.6098C122.335 11.1175 121.606 11.8427 121.169 12.713C120.659 13.6558 120.44 14.7436 120.513 15.8315C120.513 16.9193 120.731 17.9347 121.169 18.8775C121.606 19.7477 122.262 20.4004 123.137 20.9081C124.012 21.4158 124.96 21.6333 125.98 21.6333C126.928 21.6333 127.803 21.4883 128.605 21.1257C129.407 20.8356 130.063 20.2554 130.5 19.6027V20.9806C130.5 21.1982 130.646 21.3432 130.865 21.3432H133.271C133.489 21.3432 133.635 21.1982 133.635 20.9806V6.62104C133.635 6.54852 133.635 6.40347 133.562 6.40347C133.416 6.33095 133.343 6.25842 133.198 6.25842ZM108.921 14.5986C108.994 13.8734 109.359 13.2206 109.942 12.858C110.598 12.3504 111.4 12.1328 112.202 12.1328C113.077 12.0603 113.879 12.2778 114.608 12.7855C115.191 13.2206 115.555 13.8734 115.482 14.5986H108.921ZM116.941 11.4076C115.628 10.3922 113.952 9.81206 112.275 9.9571C111.108 9.9571 109.942 10.1747 108.848 10.7549C107.901 11.2625 107.099 11.9878 106.588 12.9306C106.078 13.8734 105.787 14.9612 105.787 16.0491C105.714 17.6446 106.297 19.1676 107.463 20.2554C108.775 21.3432 110.452 21.8509 112.202 21.7784C113.66 21.8509 115.118 21.5608 116.43 20.8356C117.378 20.2554 118.034 19.3851 118.326 18.2973C118.399 18.1522 118.326 18.0072 118.18 18.0072H115.628C115.555 18.0072 115.41 18.0797 115.41 18.1522C114.972 19.0225 113.952 19.5302 112.421 19.5302C111.837 19.5302 111.181 19.3851 110.598 19.1676C110.088 18.95 109.723 18.5874 109.359 18.1522C109.067 17.7171 108.921 17.2094 108.921 16.7018H118.18C118.326 16.7018 118.399 16.6292 118.471 16.5567C118.544 16.4842 118.617 16.3391 118.617 16.2666V15.6864C118.69 14.0909 118.034 12.5679 116.941 11.4076ZM94.4138 14.5986C94.4867 13.8734 94.8512 13.2206 95.4344 12.858C96.0905 12.3504 96.8925 12.1328 97.6944 12.1328C98.5692 12.0603 99.3711 12.2778 100.1 12.7855C100.683 13.2206 101.048 13.8734 100.975 14.5986H94.4138ZM102.36 11.4076C101.048 10.3922 99.3711 9.81206 97.6944 9.9571C96.5279 9.9571 95.3615 10.1747 94.268 10.7549C93.3203 11.2625 92.5183 11.9878 92.008 12.9306C91.4977 13.8734 91.2061 14.9612 91.2061 16.0491C91.1332 17.6446 91.7164 19.1676 92.8829 20.2554C94.1951 21.3432 95.8718 21.8509 97.6215 21.7784C99.0795 21.8509 100.538 21.5608 101.85 20.8356C102.798 20.2554 103.454 19.3851 103.745 18.2973C103.818 18.1522 103.745 18.0072 103.599 18.0072H101.048C100.975 18.0072 100.829 18.0797 100.829 18.1522C100.392 19.0225 99.3711 19.5302 97.8402 19.5302C97.257 19.5302 96.6009 19.3851 96.0176 19.1676C95.5073 18.95 95.1428 18.5874 94.7783 18.1522C94.4867 17.7171 94.3409 17.2094 94.3409 16.7018H103.599C103.745 16.7018 103.818 16.6292 103.891 16.5567C103.964 16.4842 104.037 16.3391 104.037 16.2666V15.6864C104.11 14.0909 103.527 12.5679 102.36 11.4076ZM89.8939 10.1022C88.29 10.1022 86.832 10.8274 85.8114 12.0603V10.6098C85.8114 10.5373 85.8114 10.4648 85.7384 10.3922C85.6655 10.3197 85.5926 10.3197 85.5197 10.2472H83.114C82.8953 10.2472 82.7495 10.3922 82.7495 10.6098V21.0532C82.7495 21.2707 82.8953 21.4158 83.114 21.4158H85.5926C85.8114 21.4158 85.9572 21.2707 85.9572 21.0532V15.5414C85.9572 14.8162 86.3217 14.0909 86.9049 13.5833C87.6339 13.0031 88.5816 12.6405 89.5294 12.713H89.9668C90.1855 12.713 90.4042 12.5679 90.4042 12.3504V10.4648C90.4042 10.3922 90.3313 10.2472 90.2584 10.1747C90.1855 10.1022 90.1126 10.0296 89.9668 10.0296H89.8939V10.1022ZM55.4112 14.6711C55.4841 13.9459 55.8486 13.2932 56.4318 12.9306C57.0879 12.4229 57.8899 12.2053 58.6918 12.2053C59.5666 12.1328 60.3685 12.3504 61.0976 12.858C61.6808 13.2932 61.9724 13.9459 61.9724 14.6711H55.4112ZM63.4304 11.4076C62.1182 10.3197 60.5143 9.81206 58.8376 9.88458C57.6712 9.88458 56.5047 10.1022 55.4112 10.6823C54.4635 11.19 53.6616 11.9152 53.1512 12.858C52.6409 13.8008 52.3493 14.8887 52.3493 15.9765C52.2764 17.572 52.8596 19.095 54.0261 20.1829C55.3383 21.2707 57.015 21.7784 58.7647 21.7059C60.2227 21.7784 61.6808 21.4883 62.993 20.7631C63.9407 20.1829 64.5969 19.3126 64.8885 18.2247C64.9614 18.0797 64.8156 17.9347 64.7427 17.9347H62.1911C62.1182 17.9347 61.9724 18.0072 61.9724 18.0797C61.535 18.95 60.5143 19.4576 58.9105 19.4576C58.3273 19.4576 57.6712 19.3126 57.0879 19.095C56.5776 18.8775 56.2131 18.5148 55.8486 18.0797C55.557 17.6446 55.4112 17.1369 55.4112 16.6292H64.5969C64.7427 16.6292 64.8156 16.5567 64.8885 16.4842C64.9614 16.4117 65.0343 16.2666 65.0343 16.1941V15.6864C65.1072 14.0909 64.524 12.5679 63.4304 11.4076ZM47.1733 16.1216C47.1733 16.4842 47.1004 16.9193 46.9546 17.2819C46.8088 17.6446 46.5901 18.0072 46.2984 18.2973C46.0068 18.5874 45.5694 18.8775 45.132 19.0225C44.6946 19.1675 44.1843 19.3126 43.674 19.3126C42.7991 19.3851 41.8514 19.0225 41.2682 18.4423C40.6121 17.7896 40.3205 16.8468 40.3934 15.9765C40.3205 15.0337 40.6121 14.0909 41.2682 13.3657C41.9972 12.713 42.872 12.4229 43.8198 12.4954C44.6946 12.4229 45.6423 12.7855 46.2255 13.3657C46.5172 13.6558 46.7359 14.0184 46.8817 14.381C47.0275 14.7436 47.1004 15.1788 47.1004 15.6139L47.1733 16.1216ZM49.9435 6.33094H47.4649C47.2462 6.33094 47.1004 6.47599 47.1004 6.69356V11.7702C46.0797 10.5373 44.4759 9.88458 42.872 9.9571C41.7785 9.9571 40.7579 10.1747 39.8102 10.7549C38.9353 11.2625 38.2063 11.9878 37.7689 12.858C36.8212 14.8162 36.8212 17.0644 37.7689 19.0225C38.2063 19.8928 38.8624 20.5455 39.7373 21.0532C40.6121 21.5608 41.5598 21.7784 42.5804 21.7784C43.5282 21.7784 44.403 21.6333 45.2049 21.2707C46.0068 20.9806 46.663 20.4004 47.1004 19.7477V21.1257C47.1004 21.3432 47.2462 21.4883 47.4649 21.4883H49.8706C50.0894 21.4883 50.2352 21.3432 50.2352 21.1257V6.69356C50.2352 6.62104 50.1622 6.54852 50.1622 6.47599C50.1622 6.33095 50.0164 6.33094 49.9435 6.33094Z' fill='%23353C42'/%3E%3C/svg%3E",
        "altText": "Degreed logo"
      },
      "colors": {
        "background": "#ffffff",
        "text": "var(--apollo-color-neutral-800)",
        "highlight": "var(--apollo-color-primary-800)",
        "separator": "var(--apollo-color-neutral-200)"
      },
      "text": "Degreed Logo",
      "analytics": "global.navigation.admin.brand",
      "i18n": "global.navigation.admin.brand",
      "dgat": "global.navigation.admin.brand"
    },
    "features": {
      "beta": {
        "enabled": false,
        "visible": false,
        "text": "Beta",
        "i18n": "global.navigation.admin.features.beta",
        "dgat": "global.navigation.admin.features.beta"
      },
      "admin": {
        "enabled": true,
        "visible": true,
        "text": "Admin",
        "i18n": "global.navigation.admin.features.admin, Core_RoleAdmin",
        "dgat": "global.navigation.admin.features.admin"
      },
      "footerBranding": {
        "enabled": true,
        "visible": true,
        "text": "Powered by",
        "i18n": "global.navigation.admin.features.footer-branding, Core_PoweredBy",
        "dgat": "global.navigation.admin.features.footer-branding"
      },
      "sidebarBranding": {
        "enabled": true,
        "visible": true,
        "text": "Powered by",
        "i18n": "global.navigation.admin.features.sidebar-branding, Core_PoweredBy",
        "dgat": "global.navigation.admin.features.sidebar-branding"
      },
      "switcher": {
        "enabled": true,
        "visible": true,
        "text": "Show Learner View",
        "i18n": "global.navigation.admin.features.show-learner-view",
        "dgat": "global.navigation.admin.features.show-learner-view",
        "analytics": "global.navigation.admin.features.show-learner-view",
        "href": "/<user>/dashboard"
      },
      "extendedEnterprise": {
        "enabled": true,
        "visible": true,
        "text": "Extended Enterprise",
        "i18n": "global.navigation.admin.features.extended-enterprise",
        "dgat": "global.navigation.admin.features.extended-enterprise",
        "analytics": "global.navigation.admin.features.extended-enterprise",
        "href": "/channel",
        "blocksWhileImpersonating": true
      },
      "search": {
        "enabled": false,
        "visible": false
      },
      "addContent": {
        "enabled": false,
        "visible": false
      },
      "logOut": {
        "enabled": true,
        "visible": true,
        "text": "Log Out",
        "i18n": "global.navigation.logout",
        "dgat": "global.navigation.admin.logout",
        "analytics": "global.navigation.admin.logout",
        "href": "/account/logoff"
      }
    },
    "navigation": {
      "top": [
        {
          "headerTitle": "Insights",
          "headerTitleI18n": "global.navigation.admin.sidebar.dashboard, OrganizationsController_Insights",
          "text": "Insights",
          "i18n": "global.navigation.admin.sidebar.dashboard, OrganizationsController_Insights",
          "dgat": "global.navigation.admin.sidebar.dashboard",
          "analytics": "global.navigation.admin.sidebar.dashboard",
          "icon": "presentation-chart-line",
          "routerLink": "/orgs/<orgId>/insights/learning",
          "children": [
            {
              "text": "Learning",
              "i18n": "global.navigation.admin.sidebar.dashboard.learning, OrgSettingsNav_Learning",
              "dgat": "global.navigation.admin.sidebar.dashboard.learning",
              "analytics": "global.navigation.admin.sidebar.dashboard.learning",
              "routerLink": "/orgs/<orgId>/insights/learning",
              "end": true
            },
            {
              "text": "Skills",
              "i18n": "global.navigation.admin.sidebar.dashboard.skills, Core_Skills",
              "dgat": "global.navigation.admin.sidebar.dashboard.skills",
              "analytics": "global.navigation.admin.sidebar.dashboard.skills",
              "routerLink": "/orgs/<orgId>/insights/skills"
            },
            {
              "text": "Skill Trends",
              "i18n": "global.navigation.admin.sidebar.dashboard.skill-trends, InsightsNav_SkillTrends",
              "dgat": "global.navigation.admin.sidebar.dashboard.skill-trends",
              "analytics": "global.navigation.admin.sidebar.dashboard.skill-trends",
              "routerLink": "/orgs/<orgId>/insights/skill-trends"
            },
            {
              "text": "Learning Trends",
              "i18n": "global.navigation.admin.sidebar.dashboard.learning-trends, InsightsNav_LearningTrends",
              "dgat": "global.navigation.admin.sidebar.dashboard.learning-trends",
              "analytics": "global.navigation.admin.sidebar.dashboard.learning-trends",
              "routerLink": "/orgs/<orgId>/insights/learning-trends"
            },
            {
              "text": "Maestro Trends",
              "i18n": "global.navigation.admin.sidebar.dashboard.maestro-trends, InsightsNav_MaestroTrends",
              "dgat": "global.navigation.admin.sidebar.dashboard.maestro-trends",
              "analytics": "global.navigation.admin.sidebar.dashboard.maestro-trends",
              "routerLink": "/orgs/<orgId>/insights/maestro-trends"
            }
          ]
        },
        {
          "headerTitle": "People",
          "headerTitleI18n": "global.navigation.admin.sidebar.people, OrganizationsController_People",
          "text": "People",
          "i18n": "global.navigation.admin.sidebar.people, OrganizationsController_People",
          "dgat": "global.navigation.admin.sidebar.people",
          "analytics": "global.navigation.admin.sidebar.people",
          "icon": "users",
          "routerLink": "/orgs/<orgId>/members/users",
          "children": [
            {
              "text": "Users",
              "i18n": "global.navigation.admin.sidebar.people.users, Core_Users",
              "dgat": "global.navigation.admin.sidebar.people.users",
              "analytics": "global.navigation.admin.sidebar.people.users",
              "routerLink": "/orgs/<orgId>/members/users"
            },
            {
              "text": "Groups",
              "i18n": "global.navigation.admin.sidebar.people.groups, Core_Groups",
              "dgat": "global.navigation.admin.sidebar.people.groups",
              "analytics": "global.navigation.admin.sidebar.people.groups",
              "routerLink": "/orgs/<orgId>/groups"
            },
            {
              "text": "User Attributes",
              "i18n": "global.navigation.admin.sidebar.people.user-attributes, Attributes_UserAttributes",
              "dgat": "global.navigation.admin.sidebar.people.user-attributes",
              "analytics": "global.navigation.admin.sidebar.people.user-attributes",
              "routerLink": "/orgs/<orgId>/members/attributes"
            },
            {
              "text": "Security Roles",
              "i18n": "OrgManage_SecurityRoles",
              "dgat": "global.navigation.admin.sidebar.people.permissions",
              "analytics": "global.navigation.admin.sidebar.people.permissions",
              "routerLink": "/orgs/<orgId>/members/permissions/1"
            }
          ]
        },
        {
          "headerTitle": "Catalog",
          "headerTitleI18n": "global.navigation.admin.sidebar.catalog, Channel_CatalogNav",
          "text": "Catalog",
          "i18n": "global.navigation.admin.sidebar.catalog, Channel_CatalogNav",
          "dgat": "global.navigation.admin.sidebar.catalog",
          "analytics": "global.navigation.admin.sidebar.catalog",
          "icon": "book-open",
          "routerLink": "/orgs/<orgId>/content",
          "children": [
            {
              "text": "Content",
              "i18n": "global.navigation.admin.sidebar.catalog.content, Core_Content",
              "dgat": "global.navigation.admin.sidebar.catalog.content",
              "analytics": "global.navigation.admin.sidebar.catalog.content",
              "routerLink": "/orgs/<orgId>/content"
            },
            {
              "text": "Academies",
              "i18n": "global.navigation.admin.sidebar.catalog.academies, Core_Academies",
              "dgat": "global.navigation.admin.sidebar.catalog.academies",
              "analytics": "global.navigation.admin.sidebar.catalog.academies",
              "href": "<learnInSSOUrl>#/admin/academies?lxpAdmin=true"
            },
            {
              "text": "Pathways",
              "i18n": "global.navigation.admin.sidebar.catalog.pathways, OrganizationsController_Pathways",
              "dgat": "global.navigation.admin.sidebar.catalog.pathways",
              "analytics": "global.navigation.admin.sidebar.catalog.pathways",
              "routerLink": "/orgs/<orgId>/pathways"
            },
            {
              "text": "Plans",
              "i18n": "global.navigation.admin.sidebar.catalog.plans, OrganizationsController_Plans",
              "dgat": "global.navigation.admin.sidebar.catalog.plans",
              "analytics": "global.navigation.admin.sidebar.catalog.plans",
              "routerLink": "/orgs/<orgId>/plans"
            },
            {
              "text": "Pages",
              "i18n": "global.navigation.admin.sidebar.catalog.flexible-pages",
              "dgat": "global.navigation.admin.sidebar.catalog.flexible-pages",
              "analytics": "global.navigation.admin.sidebar.catalog.flexiblePages",
              "routerLink": "/orgs/<orgId>/pages"
            },
            {
              "text": "Assessments",
              "i18n": "global.navigation.admin.sidebar.catalog.assessments, Assess_Library_Title",
              "dgat": "global.navigation.admin.sidebar.catalog.assessments",
              "analytics": "global.navigation.admin.sidebar.catalog.assessments",
              "routerLink": "/orgs/<orgId>/assessments"
            },
            {
              "text": "Programs",
              "i18n": "global.navigation.admin.sidebar.catalog.programs, OrgManage_Programs",
              "dgat": "global.navigation.admin.sidebar.catalog.programs",
              "analytics": "global.navigation.admin.sidebar.catalog.programs",
              "routerLink": "/orgs/<orgId>/programs"
            }
          ]
        },
        {
          "headerTitle": "Skills",
          "headerTitleI18n": "global.navigation.admin.sidebar.skills, Core_Skills",
          "text": "Skills",
          "i18n": "global.navigation.admin.sidebar.skills, Core_Skills",
          "dgat": "global.navigation.admin.sidebar.skills",
          "analytics": "global.navigation.admin.sidebar.skills",
          "icon": "tag",
          "routerLink": "/orgs/<orgId>/skills-platform/dashboard",
          "children": [
            {
              "text": "Dashboard",
              "i18n": "global.navigation.admin.sidebar.skills.dashboard, NavigationSvc_DashboardTitle",
              "dgat": "global.navigation.admin.sidebar.skills.dashboard",
              "analytics": "global.navigation.admin.sidebar.skills.dashboard",
              "routerLink": "/orgs/<orgId>/skills-platform/dashboard"
            },
            {
              "text": "Inventory",
              "i18n": "global.navigation.admin.sidebar.skills.inventory, Core_Inventory",
              "dgat": "global.navigation.admin.sidebar.skills.inventory",
              "analytics": "global.navigation.admin.sidebar.skills.inventory",
              "routerLink": "/orgs/<orgId>/skills-platform/skill-inventory"
            },
            {
              "text": "Scales",
              "i18n": "global.navigation.admin.sidebar.skills.scales",
              "dgat": "global.navigation.admin.sidebar.skills.scaleslxp",
              "analytics": "global.navigation.admin.sidebar.skills.scales",
              "routerLink": "/orgs/<orgId>/skills-platform/scales"
            },
            {
              "text": "Org Skills",
              "i18n": "global.navigation.admin.sidebar.skills.skill-list",
              "dgat": "global.navigation.admin.sidebar.skills.skill-list",
              "analytics": "global.navigation.admin.sidebar.skills.skill-list",
              "routerLink": "/orgs/<orgId>/skills/list"
            },
            {
              "text": "Roles",
              "i18n": "global.navigation.admin.sidebar.skills.roles, OrgSkillsNav_Roles",
              "dgat": "global.navigation.admin.sidebar.skills.roles",
              "analytics": "global.navigation.admin.sidebar.skills.roles",
              "routerLink": "/orgs/<orgId>/skills/roles"
            },
            {
              "text": "Roles",
              "i18n": "global.navigation.admin.sidebar.skills.roles, OrgSkillsNav_Roles",
              "dgat": "global.navigation.admin.sidebar.skills.rolesskillsplus",
              "analytics": "global.navigation.admin.sidebar.skills.rolesskillsplus",
              "routerLink": "/orgs/<orgId>/skills-platform/roles"
            },
            {
              "text": "Skill Standards",
              "i18n": "global.navigation.admin.sidebar.skills.skill-standards, SkillStd_SkillStandards",
              "dgat": "global.navigation.admin.sidebar.skills.skill-standards",
              "analytics": "global.navigation.admin.sidebar.skills.skill-standards",
              "routerLink": "/orgs/<orgId>/skills/skillstandards"
            },
            {
              "text": "Publish",
              "i18n": "global.navigation.admin.sidebar.skills.publish, Core_Publish",
              "dgat": "global.navigation.admin.sidebar.skills.publish",
              "analytics": "global.navigation.admin.sidebar.skills.publish",
              "routerLink": "/orgs/<orgId>/skills-platform/publish-skills"
            },
            {
              "text": "Settings",
              "i18n": "global.navigation.admin.sidebar.skills.settings, Core_Settings",
              "dgat": "global.navigation.admin.sidebar.skills.settings",
              "analytics": "global.navigation.admin.sidebar.skills.settings",
              "routerLink": "/orgs/<orgId>/skills/settings"
            }
          ]
        },
        {
          "headerTitle": "Content Marketplace",
          "headerTitleI18n": "global.navigation.admin.sidebar.content-marketplace, Core_Marketplace",
          "text": "Content Marketplace",
          "i18n": "global.navigation.admin.sidebar.content-marketplace, Core_Marketplace",
          "dgat": "global.navigation.admin.sidebar.content-marketplace",
          "analytics": "global.navigation.admin.sidebar.content-marketplace",
          "icon": "building-storefront",
          "href": "<learnInSSOUrl>#/admin/programs"
        },
        {
          "headerTitle": "Automations",
          "headerTitleI18n": "global.navigation.admin.sidebar.automations, Automation_Automations",
          "text": "Automations",
          "i18n": "global.navigation.admin.sidebar.automations, Automation_Automations",
          "dgat": "global.navigation.admin.sidebar.automations",
          "analytics": "global.navigation.admin.sidebar.automations",
          "icon": "bolt",
          "routerLink": "/orgs/<orgId>/automations"
        },
        {
          "headerTitle": "Reporting",
          "headerTitleI18n": "global.navigation.admin.sidebar.reporting, OrganizationsController_Reporting",
          "text": "Reporting",
          "i18n": "global.navigation.admin.sidebar.reporting, OrganizationsController_Reporting",
          "dgat": "global.navigation.admin.sidebar.reporting",
          "analytics": "global.navigation.admin.sidebar.reporting",
          "icon": "document-chart-bar",
          "routerLink": "/orgs/<orgId>/reporting/downloads",
          "children": [
            {
              "text": "Analytics",
              "i18n": "global.navigation.admin.sidebar.reporting.self-service-analytics, SelfServiceAnalytics_Title",
              "dgat": "global.navigation.admin.sidebar.reporting.self-service-analytics",
              "analytics": "global.navigation.admin.sidebar.reporting.self-service-analytics",
              "routerLink": "/orgs/<orgId>/self-service-analytics",
              "blocksWhileImpersonating": true
            },
            {
              "text": "Reports",
              "i18n": "global.navigation.admin.sidebar.reporting.reports, ReportingInApp_Reports",
              "dgat": "global.navigation.admin.sidebar.reporting.reports",
              "analytics": "global.navigation.admin.sidebar.reporting.reports",
              "routerLink": "/orgs/<orgId>/reporting/downloads"
            },
            {
              "text": "Presets",
              "i18n": "global.navigation.admin.sidebar.reporting.presets, ReportingInApp_SavedPresets",
              "dgat": "global.navigation.admin.sidebar.reporting.presets",
              "analytics": "global.navigation.admin.sidebar.reporting.presets",
              "routerLink": "/orgs/<orgId>/reporting/presets"
            },
            {
              "text": "Categories",
              "i18n": "global.navigation.admin.sidebar.reporting.categories, ReportingInApp_Categories",
              "dgat": "global.navigation.admin.sidebar.reporting.categories",
              "analytics": "global.navigation.admin.sidebar.reporting.categories",
              "routerLink": "/orgs/<orgId>/reporting/create"
            },
            {
              "text": "FTP",
              "i18n": "global.navigation.admin.sidebar.reporting.ftp, OrgManage_ReportSchedule_FTP",
              "dgat": "global.navigation.admin.sidebar.reporting.ftp",
              "analytics": "global.navigation.admin.sidebar.reporting.ftp",
              "routerLink": "/orgs/<orgId>/reporting/reportSchedule"
            },
            {
              "text": "Configurations",
              "i18n": "global.navigation.admin.sidebar.reporting.configurations, Reporting_Transmitters_Configurations",
              "dgat": "global.navigation.admin.sidebar.reporting.configurations",
              "analytics": "global.navigation.admin.sidebar.reporting.configurations",
              "routerLink": "/orgs/<orgId>/reporting/configurations"
            },
            {
              "text": "Dynamic Admin Groups",
              "i18n": "global.navigation.admin.sidebar.reporting.groups, ReportingInApp_DynamicGroups",
              "dgat": "global.navigation.admin.sidebar.reporting.groups",
              "analytics": "global.navigation.admin.sidebar.reporting.groups",
              "routerLink": "/orgs/<orgId>/reporting/groups"
            },
            {
              "text": "Advanced Analytics",
              "i18n": "global.navigation.admin.sidebar.reporting.advanced-analytics",
              "dgat": "global.navigation.admin.sidebar.reporting.advanced-analytics",
              "analytics": "global.navigation.admin.sidebar.reporting.advanced-analytics",
              "href": "/analytics?tag=1",
              "target": "_blank",
              "blocksWhileImpersonating": true
            }
          ]
        },
        {
          "headerTitle": "Integrations",
          "headerTitleI18n": "global.navigation.admin.sidebar.integrations",
          "text": "Integrations",
          "i18n": "global.navigation.admin.sidebar.integrations",
          "dgat": "global.navigation.admin.sidebar.integrations",
          "analytics": "global.navigation.admin.sidebar.integrations",
          "icon": "puzzle-piece",
          "routerLink": "/orgs/<orgId>/settings/integrationProviders",
          "children": [
            {
              "text": "Connected",
              "i18n": "global.navigation.admin.sidebar.integrations.connected, Core_Connected",
              "dgat": "global.navigation.admin.sidebar.integrations.connected",
              "analytics": "global.navigation.admin.sidebar.integrations.connected",
              "routerLink": "/orgs/<orgId>/settings/integrationProviders"
            },
            {
              "text": "Directory",
              "i18n": "global.navigation.admin.sidebar.integrations.directory, Core_Directory",
              "dgat": "global.navigation.admin.sidebar.integrations.directory",
              "analytics": "global.navigation.admin.sidebar.integrations.directory",
              "hrefBuilder": "INTEGRATIONS-PROVIDER_DIRECTORY_URL",
              "target": "_blank"
            },
            {
              "text": "API Keys",
              "i18n": "global.navigation.admin.sidebar.integrations.api-keys, Integrations_APIKeys",
              "dgat": "global.navigation.admin.sidebar.integrations.api-keys",
              "analytics": "global.navigation.admin.sidebar.integrations.api-keys",
              "routerLink": "/orgs/<orgId>/settings/manageCredentials"
            },
            {
              "text": "File Upload",
              "i18n": "global.navigation.admin.sidebar.integrations.file-upload, OrganizationsController_FileUpload",
              "dgat": "global.navigation.admin.sidebar.integrations.file-upload",
              "analytics": "global.navigation.admin.sidebar.integrations.file-upload",
              "routerLink": "/orgs/<orgId>/fileupload/uploadFile"
            },
            {
              "text": "File Log",
              "i18n": "global.navigation.admin.sidebar.integrations.file-log, OrganizationsController_FileLog",
              "dgat": "global.navigation.admin.sidebar.integrations.file-log",
              "analytics": "global.navigation.admin.sidebar.integrations.file-log",
              "routerLink": "/orgs/<orgId>/fileupload/fileLog"
            },
            {
              "text": "Webhooks",
              "i18n": "global.navigation.admin.sidebar.integrations.webhooks, Webhooks_Heading",
              "dgat": "global.navigation.admin.sidebar.integrations.webhooks",
              "analytics": "global.navigation.admin.sidebar.integrations.webhooks",
              "routerLink": "/orgs/<orgId>/webhooks"
            }
          ]
        },
        {
          "headerTitle": "Maestro",
          "headerTitleI18n": "global.navigation.admin.sidebar.maestro, AppHeader_MaestroTitle",
          "text": "Maestro",
          "i18n": "global.navigation.admin.sidebar.maestro, AppHeader_MaestroTitle",
          "dgat": "global.navigation.admin.sidebar.maestro",
          "icon": "sparkles",
          "analytics": "global.navigation.admin.sidebar.maestro",
          "children": [
            {
              "text": "Experiences",
              "i18n": "global.navigation.admin.sidebar.maestro.experiences, Maestro_Experiences",
              "dgat": "global.navigation.admin.sidebar.maestro.experiences",
              "analytics": "global.navigation.admin.sidebar.maestro.experiences",
              "routerLink": "/orgs/<orgId>/maestro/experiences",
              "end": true
            },
            {
              "text": "Settings",
              "i18n": "global.navigation.admin.sidebar.maestro.settings, Core_Settings",
              "dgat": "global.navigation.admin.sidebar.maestro.settings",
              "analytics": "global.navigation.admin.sidebar.maestro.settings",
              "routerLink": "/orgs/<orgId>/maestro/settings",
              "end": true
            }
          ]
        },
        {
          "headerTitle": "Agents",
          "headerTitleI18n": "global.navigation.admin.sidebar.agents, Agents_Title",
          "text": "Agents",
          "i18n": "global.navigation.admin.sidebar.agents, Agents_Title",
          "dgat": "global.navigation.admin.sidebar.agents",
          "icon": "cpu-chip",
          "analytics": "global.navigation.admin.sidebar.agents",
          "children": [
            {
              "text": "Overview",
              "i18n": "global.navigation.admin.sidebar.agents.overview, Agents_Overview",
              "dgat": "global.navigation.admin.sidebar.agents.overview",
              "analytics": "global.navigation.admin.sidebar.agents.overview",
              "routerLink": "/orgs/<orgId>/agents",
              "end": true
            },
            {
              "text": "Settings",
              "i18n": "global.navigation.admin.sidebar.agents.settings, Core_Settings",
              "dgat": "global.navigation.admin.sidebar.agents.settings",
              "analytics": "global.navigation.admin.sidebar.agents.settings",
              "routerLink": "/orgs/<orgId>/agents/settings",
              "end": true
            }
          ]
        },
        {
          "headerTitle": "Settings",
          "headerTitleI18n": "global.navigation.admin.sidebar.settings, Core_Settings",
          "text": "Settings",
          "i18n": "global.navigation.admin.sidebar.settings, Core_Settings",
          "dgat": "global.navigation.admin.sidebar.settings",
          "analytics": "global.navigation.admin.sidebar.settings",
          "icon": "cog-6-tooth",
          "routerLink": "/orgs/<orgId>/settings/branding",
          "children": [
            {
              "text": "Branding",
              "i18n": "global.navigation.admin.sidebar.settings.branding, OrgSettingsNav_Branding",
              "dgat": "global.navigation.admin.sidebar.settings.branding",
              "analytics": "global.navigation.admin.sidebar.settings.branding",
              "routerLink": "/orgs/<orgId>/settings/branding"
            },
            {
              "text": "Home",
              "i18n": "global.navigation.admin.sidebar.settings.home, Core_Home",
              "dgat": "global.navigation.admin.sidebar.settings.home",
              "analytics": "global.navigation.admin.sidebar.settings.home",
              "routerLink": "/orgs/<orgId>/settings/home"
            },
            {
              "text": "Help Menu",
              "i18n": "global.navigation.admin.sidebar.settings.help-menu, OrgSettingsNav_HelpMenu",
              "dgat": "global.navigation.admin.sidebar.settings.help-menu",
              "analytics": "global.navigation.admin.sidebar.settings.help-menu",
              "routerLink": "/orgs/<orgId>/settings/helpMenu"
            },
            {
              "text": "Communication",
              "i18n": "global.navigation.admin.sidebar.settings.communication, User_Communications",
              "dgat": "global.navigation.admin.sidebar.settings.communication",
              "analytics": "global.navigation.admin.sidebar.settings.communication",
              "routerLink": "/orgs/<orgId>/settings/communications"
            },
            {
              "text": "FAQ",
              "i18n": "global.navigation.admin.sidebar.settings.faq, OrganizationsController_FAQ",
              "dgat": "global.navigation.admin.sidebar.settings.faq",
              "analytics": "global.navigation.admin.sidebar.settings.faq",
              "routerLink": "/orgs/<orgId>/settings/faq"
            },
            {
              "text": "Messaging",
              "i18n": "global.navigation.admin.sidebar.settings.messaging, OrganizationsController_Messaging",
              "dgat": "global.navigation.admin.sidebar.settings.messaging",
              "analytics": "global.navigation.admin.sidebar.settings.messaging",
              "routerLink": "/orgs/<orgId>/settings/messaging"
            },
            {
              "text": "Security",
              "i18n": "global.navigation.admin.sidebar.settings.security, OrgSettings_Security_PageTitle",
              "dgat": "global.navigation.admin.sidebar.settings.security",
              "analytics": "global.navigation.admin.sidebar.settings.security",
              "routerLink": "/orgs/<orgId>/settings/security"
            }
          ]
        },
        {
          "headerTitle": "Organizational Units",
          "headerTitleI18n": "global.navigation.admin.sidebar.organizational-units, OrgManage_OrgUnits",
          "text": "Organizational Units",
          "i18n": "global.navigation.admin.sidebar.organizational-units, OrgManage_OrgUnits",
          "dgat": "global.navigation.admin.sidebar.organizational-units",
          "analytics": "global.navigation.admin.sidebar.organizational-units",
          "icon": "building-office-2",
          "routerLink": "/orgs/<orgId>/orgunits"
        },
        {
          "headerTitle": "Folders",
          "headerTitleI18n": "global.navigation.admin.sidebar.folders, OrgManage_Folders",
          "text": "Folders",
          "i18n": "global.navigation.admin.sidebar.folders, OrgManage_Folders",
          "dgat": "global.navigation.admin.sidebar.folders",
          "analytics": "global.navigation.admin.sidebar.folders",
          "icon": "folder",
          "routerLink": "/orgs/<orgId>/folders"
        },
        {
          "headerTitle": "Help",
          "headerTitleI18n": "global.navigation.admin.sidebar.help, Core_Help",
          "text": "Help",
          "i18n": "global.navigation.admin.sidebar.help, Core_Help",
          "dgat": "global.navigation.admin.sidebar.help",
          "analytics": "global.navigation.admin.sidebar.help",
          "icon": "lifebuoy",
          "href": null,
          "target": "_blank",
          "children": [
            {
              "text": "Knowledge Center",
              "i18n": "global.navigation.admin.sidebar.help.knowledge-center, FeedbackPartial_KnowledgeCenter",
              "dgat": "global.navigation.admin.sidebar.help.knowledge-center",
              "analytics": "global.navigation.admin.sidebar.help.knowledge-center",
              "href": "#",
              "target": "_blank"
            },
            {
              "text": "Privacy Policy",
              "i18n": "global.navigation.admin.sidebar.help.privacy-policy, FeedbackPartial_PrivacyPolicy",
              "dgat": "global.navigation.admin.sidebar.help.privacy-policy",
              "analytics": "global.navigation.admin.sidebar.help.privacy-policy",
              "href": "/about/privacy",
              "target": "_blank"
            },
            {
              "text": "Cookie Notice",
              "i18n": "global.navigation.admin.sidebar.help.cookie-notice, OrgSettings_ShowCookiePolicyLink_Name",
              "dgat": "global.navigation.admin.sidebar.help.cookie-notice",
              "analytics": "global.navigation.admin.sidebar.help.cookie-notice",
              "href": "/api/about/cookienotice",
              "target": "_blank"
            },
            {
              "text": "Frequently Asked Questions",
              "i18n": "global.navigation.admin.sidebar.help.faq, OrgSettings_OrgSupportInfoFaq_Name",
              "dgat": "global.navigation.admin.sidebar.help.faq",
              "analytics": "global.navigation.admin.sidebar.help.faq",
              "href": "/orgs/<orgId>/settings/faq",
              "target": "_blank",
              "includeSeparator": true
            },
            {
              "text": "",
              "dgat": "global.navigation.admin.sidebar.help.custom-link",
              "analytics": "global.navigation.admin.sidebar.help.custom-link",
              "href": "#",
              "target": "_blank"
            },
            {
              "text": "",
              "dgat": "global.navigation.admin.sidebar.help.support-phone",
              "analytics": "global.navigation.admin.sidebar.help.support-phone",
              "icon": "phone",
              "href": "#",
              "includeSeparator": true
            },
            {
              "text": "",
              "dgat": "global.navigation.admin.sidebar.help.support-email",
              "analytics": "global.navigation.admin.sidebar.help.support-email",
              "icon": "envelope",
              "href": "#"
            }
          ]
        }
      ],
      "bottom": []
    }
  }
}
